import { render, staticRenderFns } from "./PackageBill.vue?vue&type=template&id=3f374ddc&scoped=true&"
import script from "./PackageBill.vue?vue&type=script&lang=js&"
export * from "./PackageBill.vue?vue&type=script&lang=js&"
import style0 from "./PackageBill.vue?vue&type=style&index=0&id=3f374ddc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f374ddc",
  null
  
)

export default component.exports